import { Component, Input } from '@angular/core';

/**
 * Header for pick-list columns: title with an optional count, an optional
 * subtitle and projected content (e.g. hints) below.
 * Use inside `<ng-template pTemplate="sourceHeader">` / `"targetHeader"`.
 */
@Component({
  selector: 'app-pick-list-header',
  standalone: true,
  template: `
    <div class="flex align-items-baseline gap-2">
      <span class="font-medium">{{ title }}</span>
      @if (count !== undefined && count !== null) {
        <span class="text-sm font-normal text-color-secondary">{{
          count
        }}</span>
      }
      <span class="ml-auto text-xs font-normal text-color-secondary">
        <ng-content select="[end]"></ng-content>
      </span>
    </div>
    @if (subtitle) {
      <div class="text-xs font-normal text-color-secondary mt-1">
        {{ subtitle }}
      </div>
    }
    <ng-content></ng-content>
  `,
})
export class PickListHeaderComponent {
  @Input({ required: true }) title = '';
  /** A number or a short summary like "9 Indikatoren · 1 Set". */
  @Input() count?: number | string | null;
  @Input() subtitle?: string;
}
